export enum APPOINTMENT_STATUS {
  APPROVED = 'approved',
  PENDING = 'pending',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
  SCHEDULED_APPROVED = 'schedule-approved',
  SCHEDULED_PENDING = 'schedule-pending',
  SCHEDULED_REJECTED = 'schedule-rejected'
}
